var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "150px" },
          attrs: {
            title: "商品模式选择",
            width: 580,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取 消",
            okText: "确 定",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-form",
            { staticClass: "model-form" },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "选择模式：",
                    labelCol: { span: 5 },
                    wrapperCol: { span: 18 },
                  },
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.goodsModel,
                        callback: function ($$v) {
                          _vm.goodsModel = $$v
                        },
                        expression: "goodsModel",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "model-item" },
                        [
                          _c("a-radio", { attrs: { value: "1" } }, [
                            _vm._v("模式一：同步总店商品"),
                          ]),
                          _c("div", { staticClass: "model-desc" }, [
                            _vm._v(
                              "子门店将和总门店的商品库存、价格保持统一，仅能操作商品上下架，无商品编辑和新增权限"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "model-item" },
                        [
                          _c("a-radio", { attrs: { value: "2" } }, [
                            _vm._v("模式二：普通商品权限"),
                          ]),
                          _c("div", { staticClass: "model-desc" }, [
                            _vm._v(
                              "子门店仅能修改商品库存和价格以及商品上下架，无商品编辑和新增权限"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "model-item" },
                        [
                          _c("a-radio", { attrs: { value: "3" } }, [
                            _vm._v("模式三：超级商品权限"),
                          ]),
                          _c("div", { staticClass: "model-desc" }, [
                            _vm._v(
                              "子门店可操作商品库存和价格、商品上下架，以及新增商品权限，请谨慎开放。"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "model-warn" }, [
                    _c("span", { staticClass: "warn-strong" }, [
                      _vm._v("特别注意："),
                    ]),
                    _vm._v(
                      "门店商品权限一旦选择后，请勿随意修改，以免造成门店商品数据错乱"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }